import { useMutation } from '@tanstack/react-query';
import { CampaignMedium } from '@prisma/client';
import useGetMarketingData from './useGetMarketingData';
import { createEmailEmbed, createSmsEmbed } from '../../services/marketing';
import { CreateTemplateEmbedResponse } from '../../types/marketing';

interface Options {
  onSuccess?: (
    result: CreateTemplateEmbedResponse,
    templateId: number,
  ) => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useCreateTemplateEmbed({ onSuccess, onError }: Options = {}) {
  const {
    data: marketingData,
    isFetching: isFetchingMarketing,
    isEnabled,
  } = useGetMarketingData();

  return useMutation({
    mutationFn: async ({
      templateId,
      medium,
    }: {
      templateId: number;
      medium: CampaignMedium;
    }) => {
      if (!marketingData?.id || isFetchingMarketing || !isEnabled) return null;
      const result =
        medium === 'EMAIL'
          ? await createEmailEmbed(marketingData.id, templateId)
          : await createSmsEmbed(marketingData.id, templateId);
      return result;
    },
    onSuccess: async (result, vars) => {
      if (!result) return;
      await onSuccess?.(result, vars.templateId);
    },
    onError,
  });
}

export default useCreateTemplateEmbed;
